// extracted by mini-css-extract-plugin
export default {"content":"App_content__4nD5C","dark":"App_dark__qooFh"};